/* eslint-disable import/prefer-default-export */
import wx from 'weixin-js-sdk';
import { stringify } from 'qs';
import { createAxiosInstance } from '../../libs/axios';

const { axiosInstance } = createAxiosInstance();

export default class WxSdk {
  constructor({
    wxConfig = {},
    signatureUrl = window.location.href.split('#/')[0]
  } = {}) {
    this.isReady = false;
    this.funcQueue = [];
    this.wxConfig = {
      debug: process.env.VUE_APP_ENV === 'development',
      appId: process.env.VUE_APP_WECHAT_APPID,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'openAddress',
        'geoLocation'
      ],
      openTagList: ['wx-open-launch-weapp'],
      ...wxConfig
    };

    this.init(signatureUrl);
  }

  init(signatureUrl) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(
          `/api/web/official_website/get_jssdk_signature?url=${encodeURIComponent(
            signatureUrl
          )}`
        )
        .then((resp) => {
          const that = this;
          const { timestamp, nonce_str: nonceStr, signature } = resp.data;
          wx.config({
            timestamp,
            nonceStr,
            signature,
            ...this.wxConfig
          });

          wx.ready(() => {
            that.isReady = true;
            resolve(wx);
          });

          wx.error((res) => {
            reject(res);
          });
        }, reject);
    });
  }

  updateShareData({
    title,
    desc,
    imgUrl,
    mpImgUrl,
    shareLink = window.location.href,
    params,
    success = () => {},
    shareSuccess = () => {}
  } = {}) {
    wx.ready(() => {
      let link = shareLink;
      const a = document.createElement('a');
      a.href = link;
      let { search } = a;
      const { hash, origin, pathname } = a;
      if (params) {
        search = search
          ? `${search}&${stringify(params)}`
          : `?${stringify(params)}`;
      }

      link = `${origin}${pathname}${search}${hash}`;

      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx.updateAppMessageShareData({
        title,
        desc,
        link,
        imgUrl,
        success // 成功回调只运行一次
      });
      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      wx.updateTimelineShareData({
        title,
        link,
        imgUrl
      });

      // 即将废弃
      wx.onMenuShareTimeline({
        title, // 分享标题
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: shareSuccess
      });
      // 即将废弃
      wx.onMenuShareAppMessage({
        title, // 分享标题
        desc, // 分享描述
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: shareSuccess
      });

      // 小程序分享
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          wx.miniProgram.postMessage({
            data: {
              shareData: {
                title,
                desc,
                link,
                imgUrl: mpImgUrl || imgUrl
              }
            }
          });
        }
      });
    });
  }

  getWx() {
    return new Promise((resolve, reject) => {
      wx.ready(() => {
        resolve(wx);
      });

      wx.error((res) => {
        reject(res);
      });
    });
  }
}
